import { useQuery } from "@tanstack/react-query";
import { useAccessToken, useTenantData } from "@/hooks";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { PaymentApi } from "@/openapi/generated";

interface UsePaymentGetByIdParams {
  paymentId: string | null | undefined;
  enabled?: boolean;
  refetchInterval?: number | false;
}

export const usePaymentGetById = ({
  paymentId,
  enabled = true,
  refetchInterval = false,
}: UsePaymentGetByIdParams) => {
  const accessToken = useAccessToken();
  const { tenantId } = useTenantData();
  const id = paymentId?.trim() ?? "";

  return useQuery({
    queryKey: [QueryKeys.Payments, "detail", id],
    queryFn: async () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(PaymentApi, accessToken);
      return service.apiPaymentsIdGet({ id, xTenantID: tenantId });
    },
    enabled: !!accessToken && !!tenantId && id.length > 0 && enabled,
    refetchInterval,
  });
};
